// Module
var code = "<div id=login-register-modal><div ng-if=\"tab === 'LOGIN'\"><login is-embedded=true></login></div><div ng-if=\"tab === 'REGISTER'\"><registration is-embedded=true></registration></div></div>";
// Exports
module.exports = code;